import styles from './styles.module.scss';

import { DragItems, DropItems } from '../../types';
import { MatrixBox, MatrixBoxProps } from '../MatrixBox';
import { Pseudocode, PseudocodeProps } from '../Pseudocode';

interface CodeWithMatrixProps extends React.HTMLAttributes<HTMLDivElement> {
    pseudocode?: PseudocodeProps;
    matrix?: MatrixBoxProps;
    validateOnDrop: any;
    currentEx: number;
    show: any;
}

export const CodeWithMatrix = ({
    pseudocode,
    matrix,
    validateOnDrop,
    currentEx,
    show,
    ...rest
}: CodeWithMatrixProps) => {
    const renderPseudocode = () => {
        return (
            <Pseudocode
                code={pseudocode?.code ? pseudocode.code : []}
                dropAreas={pseudocode?.dropAreas}
                validateOnDrop={validateOnDrop}
                currentEx={currentEx}
            />
        );
    };

    const renderMatrix = () => {
        return (
            <MatrixBox
                layout={matrix?.layout ? matrix.layout : []}
                dropAreas={matrix?.dropAreas ? matrix.dropAreas : []}
                validateOnDrop={validateOnDrop}
                currentEx={currentEx}
                show={show}
            />
        );
    };

    return (
        <div className={styles.wrapper} {...rest}>
            {renderPseudocode()}
            {renderMatrix()}
        </div>
    );
};
